import {
  Swiper,
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  A11y,
  Keyboard,
} from 'swiper';
import type { SwiperOptions } from 'swiper';

import type { AutoplayOptions } from 'swiper/types/components/autoplay';

interface ExtendedSwiperOptions extends SwiperOptions {
  showTimer?: boolean;
}

Swiper.use([
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  A11y,
  Keyboard,
]);

const init = (slider: HTMLElement) => {
  // Default options for each swiper instance
  const defaultOptions: SwiperOptions = {
    loop: true,
    speed: 500,
    autoHeight: true,
    keyboard: true,

    slideActiveClass: 'slider__slide--active',

    pagination: {
      el: slider.querySelector('.slider__pagination') as HTMLElement,
      modifierClass: 'slider__pagination--',
      bulletClass: 'slider__bullet',
      bulletActiveClass: 'slider__bullet--active',
      clickable: true,
      clickableClass: 'slider__pagination--clickable',
    },

    navigation: {
      nextEl: slider.querySelector('.slider__button--next') as HTMLElement,
      prevEl: slider.querySelector('.slider__button--prev') as HTMLElement,
      disabledClass: 'slider__button--disabled',
    },

    scrollbar: {
      el: slider.querySelector('.slider__scrollbar') as HTMLElement,
      dragClass: 'slider__dragger',
      draggable: true,
      hide: false,
    },
  };

  // If slider has custom options combine them and create
  // Swiper instance, otherwise create Swiper instance with
  // default options (custom overwrites default)
  const extendedOptions: ExtendedSwiperOptions = JSON.parse(decodeURIComponent(slider.getAttribute('data-swiper')));

  const swiperInstance = new Swiper(slider, { ...defaultOptions, ...extendedOptions });

  const swiperParams: ExtendedSwiperOptions = swiperInstance.params;

  if (swiperParams.showTimer) {
    const swiperSpeed = swiperParams?.speed;
    const autoplayOptions = swiperParams?.autoplay as AutoplayOptions;
    const autoplayDelay = autoplayOptions?.delay + swiperSpeed;

    const durationAttribute = `--timer-duration: ${autoplayDelay}ms;`;
    const stateAttribute = '--timer-play-state: paused;';

    swiperInstance.wrapperEl.setAttribute('style', durationAttribute);

    swiperInstance.on('autoplayStop', (swiper) => {
      swiper.wrapperEl.setAttribute('style', `${durationAttribute} ${stateAttribute}`);
    });
  }
};

export default init;
